import { AuthService } from '@/auth/service/auth.service';
import { DriverService } from '@/services/driver/driver.service';
import { PersonService } from '@/services/person/person.service';
import { Option } from '@/shared/select-list/select-list.component';
import { ofuscate } from '@/utils/obfuscation';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';

@Component({
  templateUrl: './select-third.component.html',
  styleUrls: ['./select-third.component.css'],
})
export class SelectThirdComponent {

  personForm: FormGroup = new FormGroup({
    filterText: new FormControl(''),
    id: new FormControl(-1),
  });

  listPersonOptions: Option[] = [];
  loadingPersonOptions: boolean = false;

  constructor(
    private driverService: DriverService,
    private personService: PersonService,
    private router: Router,
    private auth: AuthService,
  ) {

    const {
      filterText: filterText$,
    } = this.personForm.controls;

    filterText$.valueChanges
      .pipe(
        tap(() => {
          this.loadingPersonOptions = true;
        }),
        debounceTime(2000),
        switchMap((value) => this.driverService.getFilteredList(value)),
      )
      .subscribe({
        next: (options) => {
          this.listPersonOptions = options;
          this.loadingPersonOptions = false;
        },
      });

  }

  getFilteredList(value: string) {
    const thirdEmployee = this.auth.userHavePrivilege('LICENSE EXTEND THIRD_EMPLOYEE');
    const thirdContractor = this.auth.userHavePrivilege('LICENSE EXTEND THIRD_CONTRACTOR');

    if (thirdEmployee && thirdContractor) {
      return this.personService.getFilteredList(value);
    }
    if (thirdEmployee) {
      return this.personService.getFilteredListExeptContractor(value);
    }
    if (thirdContractor) {
      return this.personService.getFilteredListExeptEmployee(value);
    }
    // If user have no privileges, does nothing
    return of([]);
  }

  onSearchPersonTextChange(text: string) {
    this.personForm.patchValue({ filterText: text });
  }

  onSearchPersonSelected(id: string) {
    this.personForm.patchValue({ id: +id });
  }

  onSelectPerson() {
    const personId = this.personForm.controls.id.value;
    const ofuscatedData = ofuscate({ personId });
    this.router.navigateByUrl(`/license/extend/select-license/${ofuscatedData}`);
  }

}
